export default __webpack_public_path__ + "static/media/ss.8b2f0948.svg";